import { reduce } from 'lodash';

import './testimonial.style.sass';
import template from './testimonial.tpl.pug';

class TestimonialController {
    /* @ngInject */
    constructor($interval) {
        this.$interval = $interval;
    }

    $onInit() {
        this.current = 0;
    }

    $onChanges(changeObject) {
        if (changeObject.testimonials) {
            this.testimonial = reduce(this.testimonials, (longest, testimonial) => {
                return !longest || !longest.content || longest.content.length < testimonial.content.length
                    ? testimonial
                    : longest;
            }, null);
        }
    }

    $onDestroy() {
        this.stopAutomaticCycle();
    }

    get current() {
        return this._current;
    }

    set current(value) {
        this.stopAutomaticCycle();

        value = value >= 0
            ? value % this.testimonials.length
            : (this.testimonials.length + value) % this.testimonials.length;

        if (this._current != null) {
            if (this._current < value) {
                this.leftIn = null;
                this.leftOut = this._current;
                this.rightIn = value;
                this.rightOut = null;
            } else if (this._current > value) {
                this.leftIn = value;
                this.leftOut = null;
                this.rightOut = this._current;
                this.rightIn = null;
            }
        }

        this._current = value;

        this.startAutomaticCycle();
    }

    select(index) {
        this.current = index;
    }

    selectPrevious() {
        return this.select(this.current - 1);
    }

    selectNext() {
        return this.select(this.current + 1);
    }

    startAutomaticCycle() {
        this.switchIntervalId = this.$interval(this.selectNext.bind(this), this.switchDelay || 5000);
    }

    stopAutomaticCycle() {
        this.$interval.cancel(this.switchIntervalId);
    }
}

export default {
    selector: 'dbPTestimonial',
    template: template(),
    controller: TestimonialController,
    bindings: {
        testimonials: '<',
        switchDelay: '<'
    }
};



// WEBPACK FOOTER //
// ./src/presentation/component/testimonial/testimonial.cmpt.js